import updateHomepageSettingsHome from '../../../actions/siteadmin/updateHomepageSettingsHome'
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateHomepageSettingsHome(values))
}

export default submit;